import React from "react";
import "./AuthCard.scss";
function AuthCard({ title, children }) {
  return (
    <div className="authCard py-8 sm:px-10 rounded-2xl  sm:w-[500px] w-full px-6 ">
      <div className="text-2xl font-N_Medium">{title}</div>

      <div className="mt-8">

      {children}
      </div>
    </div>
  );
}

export default AuthCard;
